import * as Yup from "yup";

import { variables } from "../../Variables";

const { required, IsEmail } = variables;

export const addvalidation = Yup.object({
  email: Yup.string().required(required).email(IsEmail),
  name: Yup.string()
    .required("Please enter the required field")
    .matches(/^[aA-zZ\s]+$/, "Only Alphabets are Allowed for this Field "),
  population: Yup.number().required(required),
});
